import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL =
  process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/accounts/loyalty'
const API_URL_NOTE =
  process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/accounts/note'

const API_URL_EMPLOYEE =
  process.env.VUE_APP_BASE_API_URL + '/api/v1/employee/accounts/loyalty'

class AccountApi {
  add(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  remove(data) {
    return axios.delete(API_URL, { data: data, headers: authHeader() })
  }

  employeeAdd(data) {
    return axios.post(API_URL_EMPLOYEE, data, { headers: authHeader() })
  }

  employeeRemove(data) {
    return axios.delete(API_URL_EMPLOYEE, { data: data, headers: authHeader() })
  }

  updateCustomerNote(data) {
    return axios.put(API_URL_NOTE, data, { headers: authHeader() })
  }
}

export default new AccountApi()
